export default "skymp5-front/1cef3a87bcef1e7ff487163c91478424.png";